module.exports = __webpack_public_path__ + "img/product-core-1.e7af1804.png";